namespace Nobox.Nobox {
    export interface StatistikRow {
        Id?: number;
        TenantId?: number;
        ChannelId?: number;
        ThBln?: string;
        T1B?: number;
        T1E?: number;
        T2B?: number;
        T2E?: number;
        T3B?: number;
        T3E?: number;
        T4B?: number;
        T4E?: number;
        T5B?: number;
        T5E?: number;
        T6B?: number;
        T6E?: number;
        T7B?: number;
        T7E?: number;
        T8B?: number;
        T8E?: number;
        T9B?: number;
        T9E?: number;
        T10B?: number;
        T10E?: number;
        T11B?: number;
        T11E?: number;
        T12B?: number;
        T12E?: number;
        T13B?: number;
        T13E?: number;
        T14B?: number;
        T14E?: number;
        T15B?: number;
        T15E?: number;
        T16B?: number;
        T16E?: number;
        T17B?: number;
        T17E?: number;
        T18B?: number;
        T18E?: number;
        T19B?: number;
        T19E?: number;
        T20B?: number;
        T20E?: number;
        T21B?: number;
        T21E?: number;
        T22B?: number;
        T22E?: number;
        T23B?: number;
        T23E?: number;
        T24B?: number;
        T24E?: number;
        T25B?: number;
        T25E?: number;
        T26B?: number;
        T26E?: number;
        T27B?: number;
        T27E?: number;
        T28B?: number;
        T28E?: number;
        T29B?: number;
        T29E?: number;
        T30B?: number;
        T30E?: number;
        T31B?: number;
        T31E?: number;
    }

    export namespace StatistikRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Nobox.Statistik';
        export const deletePermission = 'Contact:Delete';
        export const insertPermission = 'Contact:Modify';
        export const readPermission = 'Contact:View';
        export const updatePermission = 'Contact:Modify';

        export declare const enum Fields {
            Id = "Id",
            TenantId = "TenantId",
            ChannelId = "ChannelId",
            ThBln = "ThBln",
            T1B = "T1B",
            T1E = "T1E",
            T2B = "T2B",
            T2E = "T2E",
            T3B = "T3B",
            T3E = "T3E",
            T4B = "T4B",
            T4E = "T4E",
            T5B = "T5B",
            T5E = "T5E",
            T6B = "T6B",
            T6E = "T6E",
            T7B = "T7B",
            T7E = "T7E",
            T8B = "T8B",
            T8E = "T8E",
            T9B = "T9B",
            T9E = "T9E",
            T10B = "T10B",
            T10E = "T10E",
            T11B = "T11B",
            T11E = "T11E",
            T12B = "T12B",
            T12E = "T12E",
            T13B = "T13B",
            T13E = "T13E",
            T14B = "T14B",
            T14E = "T14E",
            T15B = "T15B",
            T15E = "T15E",
            T16B = "T16B",
            T16E = "T16E",
            T17B = "T17B",
            T17E = "T17E",
            T18B = "T18B",
            T18E = "T18E",
            T19B = "T19B",
            T19E = "T19E",
            T20B = "T20B",
            T20E = "T20E",
            T21B = "T21B",
            T21E = "T21E",
            T22B = "T22B",
            T22E = "T22E",
            T23B = "T23B",
            T23E = "T23E",
            T24B = "T24B",
            T24E = "T24E",
            T25B = "T25B",
            T25E = "T25E",
            T26B = "T26B",
            T26E = "T26E",
            T27B = "T27B",
            T27E = "T27E",
            T28B = "T28B",
            T28E = "T28E",
            T29B = "T29B",
            T29E = "T29E",
            T30B = "T30B",
            T30E = "T30E",
            T31B = "T31B",
            T31E = "T31E"
        }
    }
}
